import { render, staticRenderFns } from "./CalendarioTabela.vue?vue&type=template&id=5015f734&"
import script from "./CalendarioTabela.vue?vue&type=script&lang=js&"
export * from "./CalendarioTabela.vue?vue&type=script&lang=js&"
import style0 from "./CalendarioTabela.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/calendario/CalendarioTabela.vue
// module id = 1090
// module chunks = 28